import React from 'react';

import CarsSecondSideBar from '../secondSideBars/carsSecondSideBar'

import SideBarInner from './../../../shared/sideBarInner'
import CarsSortPanel from './../cars/carsSortPanel'
import CarsListWrapper from './../cars/carsListWrapper'
import CarsPaginationWrapper from './../cars/carsPaginationWrapper'
import SideBar from './../../sides/sideBar'
import CarsTitleClosedBar from './../cars/carsTitleClosedBar'
import CarsTitleBar from './../cars/carsTitleBar'
import CarsPaginationSettingsPanel from './../cars/carsPaginationSettingsPanel'

import styles from './carsBar.module.scss'

const CarsBar = () => {
  return (
    <div className={styles.sideBarsWrapper}>
      <SideBar
        TitleClosed={<CarsTitleClosedBar />}
      >
        <div className={styles.carsBar}>
          <SideBarInner>
            <CarsTitleBar />
          </SideBarInner>

          <SideBarInner>
            <CarsSortPanel />
          </SideBarInner>

          <SideBarInner>
            <CarsPaginationSettingsPanel />

            <div className={styles.container_carsList}>
              <CarsListWrapper />
          {/*     <div className={styles.container_carsPaginationWrapper}>
                <CarsPaginationWrapper />
              </div> */}
            </div>
          </SideBarInner>
        </div>
      </SideBar>

      <CarsSecondSideBar />
    </div>
  )
}

export default React.memo(CarsBar)
